export default function CheckboxField({
  field,
  value = false,
  onChange,
  error,
  disabled,
}) {
  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__option">
        <input
          type="checkbox"
          checked={!!value}
          disabled={disabled}
          onChange={(e) => onChange(field.key, e.target.checked)}
        />

        <span>
          {field.label}
          {field.required && (
            <span className="dynamic-field-control__required">*</span>
          )}
        </span>
      </label>

      {field.help_text && (
        <p className="dynamic-field-control__help">{field.help_text}</p>
      )}
      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
